import { Box } from '@mui/material';
import React, { useState } from 'react';
import { KitButton, KitCard, KitList } from '../common/MobileKit';
import { KitEmptyNote } from '../common/MobileDashboardKit';

/**
 * Peças compartilhadas pelas listas dos relatórios mobile (Ordens, Produtos, Estoque):
 * lista paginada com "Carregar mais" (20 por vez), no mesmo estilo de `SalesList`.
 * Só apresentação: quem filtra/ordena os dados é a tela do relatório.
 */

// `.list` + "Exibindo X de Y <noun>" + "Carregar mais".
export function PagedList({ rows, renderRow, pageSize = 20, noun, empty }) {
    const [visible, setVisible] = useState(pageSize);
    if (rows.length === 0) return <KitCard><KitEmptyNote>{empty}</KitEmptyNote></KitCard>;
    const shown = rows.slice(0, visible);
    return (
        <>
            <KitList>
                {shown.map((row, index) => <React.Fragment key={index}>{renderRow(row, index)}</React.Fragment>)}
            </KitList>
            <Box sx={{ textAlign: 'center', fontSize: 12, color: 'text.disabled', m: '10px 0 6px', lineHeight: 1.4 }}>
                Exibindo {shown.length} de {rows.length} {noun}
            </Box>
            {visible < rows.length && (
                <KitButton block sx={{ width: '100%' }} onClick={() => setVisible((v) => v + pageSize)}>Carregar mais</KitButton>
            )}
        </>
    );
}

// Linha de lista com conteúdo livre (`.item` sem o layout fixo título/subtítulo).
export function ListBlock({ onClick, children, sx }) {
    const clickable = Boolean(onClick);
    return (
        <Box
            component={clickable ? 'a' : 'div'}
            role={clickable ? 'link' : undefined}
            tabIndex={clickable ? 0 : undefined}
            onClick={onClick}
            onKeyDown={clickable ? (e) => { if (e.key === 'Enter') onClick(); } : undefined}
            sx={{
                display: 'block',
                p: '13px 14px',
                boxSizing: 'border-box',
                borderBottom: '1px solid',
                borderColor: 'divider',
                color: 'text.primary',
                textDecoration: 'none',
                cursor: clickable ? 'pointer' : 'default',
                '&:last-child': { borderBottom: 0 },
                ...(clickable ? { '&:active': { backgroundColor: 'background.subtle' } } : {}),
                ...sx,
            }}
        >
            {children}
        </Box>
    );
}

// Rótulo pequeno + valor (`.kv` compacto) usado em grades de 2/3 colunas.
export function MiniStat({ label, value, strong, muted }) {
    return (
        <Box sx={{ minWidth: 0 }}>
            <Box sx={{ fontSize: 11, color: 'text.disabled', lineHeight: 1.4 }}>{label}</Box>
            <Box sx={{ fontSize: strong ? 15 : 12.5, fontWeight: strong ? 800 : 700, lineHeight: 1.4, color: muted ? 'text.disabled' : 'text.primary', overflowWrap: 'anywhere' }}>{value}</Box>
        </Box>
    );
}
